// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { FormState } from "@hex-insights/forms";
import { PermissionGroupFilterInput } from "../../../Utilities";
import * as PermissionGroupFilterFormValues from "./form-values";

export function countActiveStandardFilters<
	K extends keyof PermissionGroupFilterFormValues.FilterFormValues = keyof PermissionGroupFilterFormValues.FilterFormValues,
>(_formValues: Pick<PermissionGroupFilterFormValues.FilterFormValues, K>) {
	return 0;
}

export function clearStandardFilters<
	K extends keyof PermissionGroupFilterFormValues.FilterFormValues = keyof PermissionGroupFilterFormValues.FilterFormValues,
>(_formState: FormState<Pick<PermissionGroupFilterFormValues.FilterFormValues, K>>) {}

export function resetStandardFilters<
	K extends keyof PermissionGroupFilterFormValues.FilterFormValues = keyof PermissionGroupFilterFormValues.FilterFormValues,
>(
	_formState: FormState<Pick<PermissionGroupFilterFormValues.FilterFormValues, K>>,
	_initial: PermissionGroupFilterFormValues.FilterFormValues,
) {}

export function prepareFormValuesForConversion<
	K extends keyof PermissionGroupFilterFormValues.FilterFormValues = keyof PermissionGroupFilterFormValues.FilterFormValues,
>(formValues: Pick<PermissionGroupFilterFormValues.FilterFormValues, K>) {
	return formValues;
}

export function toFilterInputs<
	K extends keyof PermissionGroupFilterFormValues.FilterFormValues = keyof PermissionGroupFilterFormValues.FilterFormValues,
>(
	_formValues: Pick<PermissionGroupFilterFormValues.FilterFormValues, K>,
	filterInput: PermissionGroupFilterInput,
): PermissionGroupFilterInput {
	return filterInput;
}
